import React, {useState} from 'react';
import { SafeAreaView } from 'react-native-safe-area-context';
import { Button, Divider, Layout, Text, Icon } from '@ui-kitten/components';
import { StyleSheet, View, TouchableOpacity } from 'react-native';
import moment from 'jalali-moment'
import { useIsFocused } from "@react-navigation/native";
import trackerApi from '../../api/tracker';
import AsyncStorage from '@react-native-async-storage/async-storage';
import * as RootNavigation from '../../../root.navigation.js';

const NewIcon = (props) => (
  <Icon {...props}
    style={[props.style, {width:30,height:30, marginTop:5 }]}
    fill = '#f5f5f5'
    name='file-text'/>
);
const DoneIcon = (props) => (
  <Icon {...props}
    style={[props.style, {width:30,height:30, marginTop:5}]}
    fill = '#f5f5f5'
    name='checkmark-square'/>
);
const EmailIcon = (props) => (
  <Icon {...props}
    style={[props.style, {width:30,height:30, marginTop:5}]}
    fill = '#f5f5f5'
    name='email'/>
);
export const InfoCards = () => {
  const isVisible = useIsFocused();
  const [count, setCount] = useState({})
  const getData = async ()=>{
    const token =  await AsyncStorage.getItem('userId');
    const response = await trackerApi.post('/invoice/agent_dashboard',null, {
      headers: {Authorization: `Bearer ${token}`}
    });
    if(response.data.status) setCount(response.data);
    console.log(response.data);
  }

  React.useEffect(()=>{
    getData()
  },[isVisible])


  return (
    <Layout level='2'>
      <Layout level='2' style={styles.container}>
        <Layout style={{...styles.card1, backgroundColor:'#005975'}} >
          <Layout style={{backgroundColor:'#005975', alignItems:'flex-start'}}>
            <Text style={styles.text} category='h6'>{count.newTask ? count.newTask : '0'}</Text>
            <Text style={styles.text} category='c2'>کار جدید</Text>
          </Layout>
          <NewIcon />
        </Layout>
        <TouchableOpacity style={{...styles.card2, backgroundColor:'#007289'}} onPress={()=>{RootNavigation.navigate('CompletedTasks')}}>
          <View style={{ alignItems:'flex-start'}}>
            <Text style={styles.text} category='h6'>{count.doneTask ? count.doneTask : '0'}</Text>
            <Text style={styles.text} category='c2'>تکمیل شده</Text>
          </View>
          <DoneIcon />
        </TouchableOpacity>
        <TouchableOpacity style={{...styles.card2, backgroundColor:'#2EABB8'}} onPress={()=>{RootNavigation.navigate('OpenTasks')}}>
          <View style={{ alignItems:'flex-start'}}>
            <Text style={styles.text} category='h6'>{count.currentTask ? count.currentTask : '0'}</Text>
            <Text style={styles.text} category='c2'>در جریان</Text>
          </View>
          <EmailIcon />
        </TouchableOpacity>

      </Layout>

    </Layout>
  );
};

const styles = StyleSheet.create({
  container: {
    flexDirection: 'row',
    justifyContent:'space-between',

  },
  card1: {
    marginLeft: 15,
    marginRight:5,
    marginVertical:5,
    borderRadius:10,
    minHeight:65,
    flexDirection:'row',
    paddingHorizontal:10,
    paddingTop:5,
    justifyContent: 'space-between',
    alignItems:'flex-start',
    flex:1,
  },
  card2: {
    marginRight: 15,
    marginLeft:5,
    marginVertical:5,
    borderRadius:10,
    minHeight:65,
    flexDirection:'row',
    paddingHorizontal:10,
    paddingTop:5,
    justifyContent: 'space-between',
    alignItems:'flex-start',
    flex:1,
  },
  text:{
    color:'#f5f5f5',
  }

});
